export default __webpack_public_path__ + "static/media/pac-shark.eb212c7d.png";